import { api } from './client';
import type { MemberDto, WorkspaceDto } from './types';

export function listWorkspaces(): Promise<WorkspaceDto[]> {
  return api<WorkspaceDto[]>('/workspaces');
}

export function createWorkspace(name: string): Promise<WorkspaceDto> {
  return api<WorkspaceDto>('/workspaces', { method: 'POST', body: { name } });
}

export function listMembers(workspaceId: string): Promise<MemberDto[]> {
  return api<MemberDto[]>(`/workspaces/${workspaceId}/members`);
}

export function inviteMember(workspaceId: string, email: string): Promise<void> {
  return api<void>(`/workspaces/${workspaceId}/members`, { method: 'POST', body: { email } });
}
